import { Route } from 'react-router-dom';

import { NotificationGatewayDetailPage } from './pages/notification-gateway-detail-page.js';
import { NotificationGatewayFormPage } from './pages/notification-gateway-form-page.js';
import { NotificationGatewayListPage } from './pages/notification-gateway-list-page.js';

/**
 * Notification gateway routes, served under /notifications.
 *
 * The static /new route is listed before the /:gatewayId parameter route so a
 * reader does not have to know React Router's ranking to see which matches.
 */
export function notificationGatewayRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/notifications" element={<NotificationGatewayListPage />} />
      <Route path="/notifications/new" element={<NotificationGatewayFormPage />} />
      <Route path="/notifications/:gatewayId/edit" element={<NotificationGatewayFormPage />} />
      <Route path="/notifications/:gatewayId" element={<NotificationGatewayDetailPage />} />
    </>
  );
}
